import {
  pgTable,
  index,
  timestamp,
  varchar,
  primaryKey
} from "drizzle-orm/pg-core";
import { users } from './users';

// OAuth states table for Gmail OAuth flow persistence
export const oauthStates = pgTable("oauth_states", {
  stateToken: varchar("state_token").primaryKey(),
  userId: varchar("user_id").references(() => users.id).notNull(),
  expiresAt: timestamp("expires_at").notNull(),
  createdAt: timestamp("created_at").defaultNow().notNull(),
}, (table) => [
  index("idx_oauth_states_user_id").on(table.userId),
  index("idx_oauth_states_expires_at").on(table.expiresAt),
]);
